import React from "react";
const Timer = () => {
    return (
        <>
            {/* countdown */}
            <div className="_nft_count_wrapper">
                <div className="_nft_count_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_nft_count_content">
                                    <h3 className="_nft_count_content_title">
                                        Time Left
                                    </h3>
                                    <p id="example_count" className="_nft_count_content_title _nft_count_content_title_countdown">
                                        <span className="hours">00</span>h <span className="minutes">00</span>m <span
                                            className="seconds">00</span>s
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* countdown */}
        </>
    )
}
export default Timer;